export enum IS_EXPIRE_ENUM {
  YES = 1,
  NO = 2,
}
